import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import { Form, Row, Col, Button } from "react-bootstrap";
import _fetch from "../config/api";
import toasted from "../config/toast";
import { api_url } from "../config/Config";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const togglePassword = () => setShowPassword((prev) => !prev);
  const [btnDisable, setBtnDisable] = useState(false);

  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  const submitLogin = async (e) => {
    e.preventDefault();

    if (!emailOrPhone || !password) {
      toasted.error("Please fill in all fields.");
      return;
    }

    setBtnDisable(true);

    const data = {
      emailOrPhone: emailOrPhone,
      password: password,
    };

    try {
      const res = await _fetch(`${api_url}auth/signin`, "POST", data, {});

      if (res?.status === true) {
        toasted.success(res?.message || "Login successful!");

        // store token and user info
        localStorage.setItem("auth", "true");
        localStorage.setItem("accessToken", res?.token);
        localStorage.setItem("user", JSON.stringify(res?.userDetails));

        // redirect user
        navigate("/dashboard");
      } else {
        toasted.error(res?.message || "Invalid login credentials.");
      }
    } catch (error) {
      toasted.error("Something went wrong. Please try again.");
      console.error("Login error:", error);
    } finally {
      setBtnDisable(false);
    }
  };

  const getIconClass = () => {
    return showPassword ? "bi bi-eye-fill" : "bi bi-eye-slash-fill";
  };

  return (
    <div className="Login_sec">
      <Container>
        <Row className="justify-content-center">
          <Col lg={6}>
            <div className="login_form">
              <div className="login_user">
                <span>
                  <i className="bi bi-person-fill"></i>
                </span>
                <h5>Sign In</h5>
              </div>

              <Form onSubmit={submitLogin}>
                {/* Email / Phone Field */}
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Email / Phone</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter email or phone number"
                    value={emailOrPhone}
                    onChange={(e) => setEmailOrPhone(e.target.value)}
                    required
                  />
                </Form.Group>

                {/* Password Field */}
                <Form.Group
                  className="mb-3 position-relative"
                  controlId="formBasicPassword"
                >
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <i
                    className={`${getIconClass()} password-toggle-icon`}
                    onClick={togglePassword}
                  ></i>
                </Form.Group>

                {/* Remember Me + Forgot Password */}
                <Form.Group className="mb-3" controlId="formBasicCheckbox">
                  <div className="login_checkbox">
                    <Form.Check type="checkbox" label="Remember me" />
                    <a href="/forget" className="">
                      Forgot Password?
                    </a>
                  </div>
                </Form.Group>

                {/* Submit Button */}
                <div className="login_btn text-center">
                  <Button
                    type="submit"
                    disabled={btnDisable}
                    className="btn btn-primary w-100"
                  >
                    {btnDisable ? "Signing In..." : "Sign In"}
                  </Button>
                </div>
              </Form>

              {/* Social Login */}
              <div className="other_sign text-center mt-4">
                <p>or Sign in with</p>
                <div className="social_btn_sign">
                  <a href="#">
                    {/* <img src={google_img} alt="google_icon" /> */}
                    Google
                  </a>
                  <a href="#">
                    {/* <img src={facebook_img} alt="facebook_icon" /> */}
                    Facebook
                  </a>
                </div>
                <h6 className="mt-3">
                  Enjoy New Experience? <a href="/register">Sign Up</a>
                </h6>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
